import { create } from 'zustand'
import { getMe } from '~/api/auth'

// 어드민 인증 전역 상태. 세션(HTTP-only 쿠키 `admin_token`) 기반.
//
// 토큰은 JS가 접근할 수 없는 HTTP-only 쿠키에 있으므로 스토어/세션스토리지에 보관하지
// 않는다. 앱 로드 시 `GET /api/auth/me`로 세션을 확인해 role을 채운다(로그인은 knoka SSO
// 전용 — 서버사이드 리다이렉트 흐름이라 토큰을 프런트가 다루지 않는다).

/** 세션 확인 진행 상태. unknown=확인 전(초기 깜빡임 방지용). */
export type AuthStatus = 'unknown' | 'authenticated' | 'unauthenticated'

interface AuthState {
    adminRole: string | null
    email: string | null
    status: AuthStatus

    /** 세션 정보를 반영한다(checkSession 성공). status=authenticated. */
    setAuth(me: { role: string; email?: string | null }): void
    /** 인증 상태를 비운다(로그아웃/만료/401). status=unauthenticated. */
    clear(): void
    /** `/api/auth/me`로 세션을 확인해 role/status를 동기화한다(앱 로드·콜백 복귀 시). */
    checkSession(): Promise<void>
}

export const useAuthStore = create<AuthState>()((set) => ({
    adminRole: null,
    email: null,
    status: 'unknown',

    setAuth: (me) =>
        set({
            adminRole: me.role,
            email: me.email ?? null,
            status: 'authenticated',
        }),

    clear: () => set({ adminRole: null, email: null, status: 'unauthenticated' }),

    checkSession: async () => {
        try {
            const me = await getMe()
            set({
                adminRole: me.role,
                email: me.email ?? null,
                status: 'authenticated',
            })
        } catch {
            set({ adminRole: null, email: null, status: 'unauthenticated' })
        }
    },
}))
